import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App, AppSubroute } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { JhpActions } from '../jhpActions';

export function* handleJhpNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    JhpActions.HANDLE_JHP_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleJhpNavigationToAngebot, App.JHP),
  );
}

export function* handleJhpNavigationToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.JHP,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationResult,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (
    !(
      contractAppId === App.JHP &&
      contractAngebotsId === state.angebotsId &&
      contractValidationResult == null
    )
  ) {
    return;
  }

  yield put(new JhpActions().preiseRequested());
  yield put(new JhpActions().zumAngebotButtonClicked());
  const navRoute: NavigationRoute = {
    appId: App.JHP,
    subroute: AppSubroute.TAA_ANGEBOT,
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
